module.exports = __webpack_public_path__ + "img/subscription.c56b85a9.svg";